import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { UniverseComponent } from 'src/domains/common/universes';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { useCommon } from 'src/domains/common/Common';

export const HeaderLogo = observer('HeaderLogo', () => {
    const common = useCommon();
    const appCasinoState = AppCasinoState.get(common);

    const { gameModalState } = appCasinoState;

    return (
        <UniverseComponent>
            {(universeVersion): React.ReactElement => (
                <universeVersion.headerLink
                    onClick={gameModalState.closeGameAndRedirectToHomePage}
                    dataTest='operator-logo'
                >
                    <universeVersion.headerLogo />
                </universeVersion.headerLink>
            )}
        </UniverseComponent>
    );
});
